exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.page {\n  width: 10rem;\n  height: 100%;\n  /* overflow: scroll; */\n}", ""]);

// exports
